<template>
    <div>
        <h1>Molecules</h1>
        <ds-molecules-list />
    </div>
</template>
